import React from 'react';
import PropTypes from 'prop-types';
import ContentContainer from '@nerdwallet/react-content-container';
import styles from './flow-container.module.less';

var FlowContainer = function FlowContainer(_ref) {
  var children = _ref.children,
      header = _ref.header;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, header, /*#__PURE__*/React.createElement(ContentContainer, {
    className: styles.body
  }, children));
};

FlowContainer.displayName = 'FlowContainer';
FlowContainer.propTypes = {
  children: PropTypes.node,
  header: PropTypes.element
};
FlowContainer.defaultProps = {
  children: null,
  header: null
};
export default FlowContainer;